const ACTIVE_ORGANIZATION_STORAGE_KEY = "active_organization_id";

const getPreferredStorage = () => {
    if (localStorage.getItem("access_token")) {
        return localStorage;
    }
    if (sessionStorage.getItem("access_token")) {
        return sessionStorage;
    }
    return localStorage;
};

const normalizeOrganizationId = (organizationId) => {
    if (organizationId === null || organizationId === undefined || organizationId === "") {
        return null;
    }

    const parsed = Number(organizationId);
    if (!Number.isInteger(parsed) || parsed <= 0) {
        return null;
    }
    return parsed;
};

export const getStoredActiveOrganizationId = () => {
    const storage = getPreferredStorage();
    return normalizeOrganizationId(storage.getItem(ACTIVE_ORGANIZATION_STORAGE_KEY));
};

export const setStoredActiveOrganizationId = (organizationId) => {
    const normalizedId = normalizeOrganizationId(organizationId);
    const storage = getPreferredStorage();

    if (normalizedId === null) {
        storage.removeItem(ACTIVE_ORGANIZATION_STORAGE_KEY);
        return;
    }

    storage.setItem(ACTIVE_ORGANIZATION_STORAGE_KEY, String(normalizedId));
};

export const clearStoredActiveOrganizationId = () => {
    localStorage.removeItem(ACTIVE_ORGANIZATION_STORAGE_KEY);
    sessionStorage.removeItem(ACTIVE_ORGANIZATION_STORAGE_KEY);
};

export const resolveActiveOrganization = (organizations = [], preferredOrganizationId = null, fallbackOrganizationId = null) => {
    const normalizedPreferredId = normalizeOrganizationId(preferredOrganizationId);
    const normalizedFallbackId = normalizeOrganizationId(fallbackOrganizationId);

    if (!Array.isArray(organizations) || organizations.length === 0) {
        return null;
    }

    if (normalizedPreferredId !== null) {
        const matchedPreferred = organizations.find((organization) => organization.id === normalizedPreferredId);
        if (matchedPreferred) {
            return matchedPreferred;
        }
    }

    if (normalizedFallbackId !== null) {
        const matchedFallback = organizations.find((organization) => organization.id === normalizedFallbackId);
        if (matchedFallback) {
            return matchedFallback;
        }
    }

    return organizations[0];
};

export { ACTIVE_ORGANIZATION_STORAGE_KEY, normalizeOrganizationId };
